import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface UseWhatsappCountsProps {
  from?: string | null;
  to?: string | null;
  billingAccountId?: string;
}

export const useWhatsappCounts = ({ from, to, billingAccountId }: UseWhatsappCountsProps) => {
  const queryParams = new URLSearchParams();
  if (from) queryParams.append('startDate', from);
  if (to) queryParams.append('endDate', to);
  if (billingAccountId) queryParams.append('billingAccountId', billingAccountId);

  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['whatsapp-counts', from, to, billingAccountId],
    queryFn: async () => {
      const response = await fetchAPI<{ message: string; data: WhatsAppCount[] }>({
        method: 'GET',
        route: 'whatsapp',
        queryString
      });
      return response;
    },
    enabled: !!from && !!to
  });
};

export default useWhatsappCounts;
